export enum CustomContentTypes {
  Cbor = 'application/cbor'
}

export enum InitialisationErrorCodes {
  EnvironmentMisconfiguration
}